import React from "react";

import {MuiIcon, MuiIconExternalProps} from "./MuiIcon";

export const JumpToElementIcon = React.forwardRef<HTMLElement, MuiIconExternalProps>(
    (props: MuiIconExternalProps, ref) => {
        return (
            <MuiIcon {...props}
                     ref={ref}
            >{'\uf719'}</MuiIcon>
        );
    })
